var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('b-container',{staticClass:"onboarding-profile-page page"},[_c('div',{staticClass:"page__card"},[_c('div',{staticClass:"page__card__content"},[_c('onboarding-profile-form')],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }